import React, { useEffect } from 'react';

// reactstrap components
import { Container } from "reactstrap";
import ProgressBar from "components/ProgressBar/StepperProgress";

// services
import { showMessage } from "services/message.js";
import { api_GET } from "services/api_service.js";

// views
import Identificacao from "views/Shared/Transportador/Identificacao";
import Veiculos from "views/Shared/Transportador/Veiculos";
import LocaisGuarda from "views/Shared/Transportador/LocaisGuarda";
import LocaisDestinacao from "views/Shared/Transportador/LocaisDestinacao";
import Equipamentos from "views/Shared/Transportador/Equipamentos";
import Documentos from "views/Shared/Documentos";

export default function ManutencaoTransportadorForm({ item, handleReturn }) {
  const [showLoading, setshowLoading] = React.useState(false);

  const [protocolo, set_protocolo] = React.useState(item);
  const [opcao, set_opcao] = React.useState(null);

  const [step, set_step] = React.useState(0);
  const handleProximoStep = (_protocolo) => {
    if ((step == 5 && opcao.categoria.sigla != "RGG") || (step == 2 && opcao.categoria.sigla == "RGG")) {
      showMessage("Aviso", "Operação executada com sucesso!", 'success', function () {
        handleReturn();
      });
    }
    else {
      set_protocolo(_protocolo);
      set_step(step + 1);
    }
  }
  const handleStepAnterior = (_protocolo) => {
    set_protocolo(_protocolo)
    set_step(step - 1);
  }

  const [permiteManutencao, set_permiteManutencao] = React.useState(false);
  const handleVerificaPermissaoManutencao = () => {
    setshowLoading(true);

    api_GET('Protocolo/VerifyExistsRequeriments/' + protocolo.protocolo_Id).then(result => {
      setshowLoading(false);
      if (result.status !== 200) {
        showMessage("Aviso", result.data.mensagem, 'error', null);
      }
      else {
        set_permiteManutencao(result.data.sucesso);

        if (!result.data.sucesso) {
          showMessage("Aviso", "Não permitida a manutenção do cadastro. " + result.data.mensagem, 'warning', null);
        }
      }
    });
  }

  useEffect(() => {
    set_opcao({
      tipoCadastro: "Protocolo",
      segmento: "Transportador",
      categoria: item.setupSolicitacaoAcaoNovoCadastro.setupSolicitacao.categoria
    });
    set_protocolo(item);
    handleVerificaPermissaoManutencao();
  }, []);

  const steps = [];
  if (opcao != null) {
    if (opcao.categoria.sigla != "RGG")
      steps.push('Identificação', 'Veiculos', 'Guarda de Veiculos', 'Destinação', 'Equipamentos', 'Documentação');
    else
      steps.push('Identificação', 'Veiculos', 'Documentação');
  }

  return (
    <>
      {showLoading &&
        <div className="carregandoCmp">
          <div className="box">
            <img src={require("assets/img/loading.gif")}></img>
          </div>
        </div>
      }
      {protocolo != null && opcao != null && <div className="content">
        <Container className="text-center">
          <ProgressBar stepValue={step} steps={steps} />
        </Container>
        {step == 0 && <Identificacao item={protocolo} tipoCadastro="Protocolo" permiteManutencao={permiteManutencao} handleProximoStep={handleProximoStep} handleReturn={handleReturn}></Identificacao>}
        {step == 1 && <Veiculos item={protocolo} tipoCadastro="Protocolo" permiteManutencao={permiteManutencao} handleProximoStep={handleProximoStep} handleStepAnterior={handleStepAnterior}></Veiculos>}
        {opcao.categoria.sigla != "RGG" ? step == 2 && <LocaisGuarda item={protocolo} tipoCadastro="Protocolo" permiteManutencao={permiteManutencao} handleProximoStep={handleProximoStep} handleStepAnterior={handleStepAnterior}></LocaisGuarda> : ""}
        {opcao.categoria.sigla != "RGG" ? step == 3 && <LocaisDestinacao item={protocolo} tipoCadastro="Protocolo" permiteManutencao={permiteManutencao} handleProximoStep={handleProximoStep} handleStepAnterior={handleStepAnterior}></LocaisDestinacao> : ""}
        {opcao.categoria.sigla != "RGG" ? step == 4 && <Equipamentos item={protocolo} tipoCadastro="Protocolo" permiteManutencao={permiteManutencao} handleProximoStep={handleProximoStep} handleStepAnterior={handleStepAnterior}></Equipamentos> : ""}
        {opcao.categoria.sigla != "RGG" ?
          step == 5 && <Documentos item={protocolo} opcao={opcao} handleProximoStep={handleProximoStep} handleStepAnterior={handleStepAnterior}></Documentos>
          :
          step == 2 && <Documentos item={protocolo} opcao={opcao} handleProximoStep={handleProximoStep} handleStepAnterior={handleStepAnterior}></Documentos>}
      </div>}
    </>
  );
}